import { HttpHandler } from 'msw'

import { getAllSales } from './getAllSales'
import { getSale } from './getSale'

export const sales: HttpHandler[] = [getAllSales, getSale]
